export function paying(value) {
  return value.total_paying
}
